// src/components/TopBar.js
import React from 'react';
import { handleSmartBack } from '../../../shared/utils/navigationUtils';

export default function TopBar({
  headerText,
  onLeftIconClick = handleSmartBack,
  rightIconClass,
  onRightIconClick,
  rightButtonText = '',
}) {
  return (
    <div className="d-flex align-items-center bg-white justify-content-between px-3 py-2 border-bottom">
      <div className="d-flex align-items-center">
        <button
          className="btn btn-link p-0 me-2"
          onClick={onLeftIconClick}
          title="Go back"
          aria-label="Go back"
        >
          <i className="bi bi-arrow-left" style={{ fontSize: '1.2rem' }}></i>
        </button>
        <span className="fw-semibold">{headerText}</span>
      </div>
      {rightIconClass && (
        <button className="btn btn-sm btn-primary py-0" onClick={onRightIconClick}>
          <i className={`${rightIconClass} me-1`} style={{ fontSize: '1.2rem' }}></i>
          {rightButtonText}
        </button>
      )}
    </div>
  );
}